import React, { Component } from "react";
import _, { get, without } from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import api from "APP_ROOT/api";
import { Col, Row } from "react-bootstrap";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { loadRecord } from "MODULES/shared/decorators";
import { show as getCompany } from "MODULES/companies/actions";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import {
  ATTACHMENT_TYPES,
  NOT_APPROVED,
  DENIED,
  APPROVED,
  COMPANY,
  REPAIR_STATION_STATUS,
  VENDOR_STATUS,
  ULTIMATE_CONSIGNEE_FORM_URL
} from "MODULES/companies/constants";

import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import {
  CompanyPurchaseStatsDetail,
  CompanyRepairStatsDetail,
  CompanySaleStatsDetail,
  ConfirmAction,
  AuditFields,
  EditButton,
  RecordPager,
  Notes,
  Attachments,
  Authorized,
  ClipboardCopy
} from "MODULES/shared/components";
import {
  ACCOUNTING,
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  ROLES,
  WAREHOUSE
} from "MODULES/users/constants";
import Fleets from "MODULES/companies/components/Detail/Fleets/Fleets";
import { CODE, ID, NAME, TENANT } from "APP_ROOT/constants";
import { RequestUltimateConsignee } from "MODULES/companies/components/Detail/RequestUltimateConsignee/RequestUltimateConsignee";
import RequestUltimateConsigneeModal from "MODULES/companies/components/Detail/RequestUltimateConsignee/RequestUltimateConsigneeModal";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { NOTE_TYPE } from "MODULES/shared/constants";
import { Receivables } from "MODULES/companies/components/Detail/Receivables/Receivables";
import RelatedCompanies from "MODULES/companies/components/Detail/RelatedCompanies/RelatedCompanies";
import StatusBadges from "./StatusBadges";
import Contacts from "./Contacts";
import PhysicalAddresses from "./PhysicalAddresses";
import AuditTrail from "./AuditTrail";
import ShippingMethods from "./ShippingMethods";
import EditBilling from "../EditBilling";
import EditCompany from "../EditCompany";
import ApprovalsTable from "./ApprovalsTable";
import BillingTable from "./BillingTable";
import DetailsTable from "./DetailsTable";
import * as actions from "../../actions/actions";
import { CustomerRestrictionsTable } from "./CustomerRestrictionsTable/CustomerRestrictionsTable";

const ExpertHeader = ({ experts }) => {
  if (!experts || experts.length === 0) return null;

  const header =
    experts.length === 1 ? "Resident Expert:" : "Resident Experts:";

  return (
    <div>
      <h2
        style={{
          marginTop: 0,
          marginBottom: 0
        }}
      >
        {header}
      </h2>
      <p
        className="lead text-blue"
        style={{
          fontSize: 14,
          fontStyle: "italic",
          marginBottom: 10
        }}
      >
        {experts.join(" / ")}
      </p>
    </div>
  );
};

ExpertHeader.propTypes = {
  experts: PropTypes.instanceOf(Array)
};

function StatSeparator() {
  return (
    <hr
      style={{
        borderTop: "1px solid rgba(0, 0, 0, 0.15)",
        marginTop: 10,
        marginBottom: 20
      }}
    />
  );
}

export class Details extends Component {
  static propTypes = {
    company: PropTypes.instanceOf(Map),
    requestVendorApproval: PropTypes.func.isRequired,
    requestStationApproval: PropTypes.func.isRequired
  };
  constructor() {
    super();
    this.fetchCompanyStats.bind(this);
    this.state = {
      editCompanyModalOpen: false,
      editBillingModalOpen: false,
      editApprovalsModalOpen: false,
      stationConfirmModalOpen: false,
      vendorConfirmModalOpen: false,
      stats: {},
      viewAllStats: false
    };
  }

  componentDidMount() {
    const { company } = this.props;
    this.fetchCompanyStats(company);
  }

  fetchCompanyStats(company) {
    api.reports.company_stats.search(company.get(ID)).then(res => {
      this.setState({
        stats: res.data
      });
    });
  }

  toggleModalState = key => {
    const currentValue = this.state[key];
    this.setState({ [key]: !currentValue });
  };

  toggleStats = () => {
    this.setState(state => ({ viewAllStats: !state.viewAllStats }));
  };

  defaultStats() {
    const { company } = this.props;
    const { stats } = this.state;

    if (company.get("repair_station_status") === APPROVED) {
      return <CompanyRepairStatsDetail stats={stats.repairs || {}} />;
    } else if (company.get("vendor_status") === APPROVED) {
      return <CompanyPurchaseStatsDetail stats={stats.purchases || {}} />;
    }

    return <CompanySaleStatsDetail stats={stats.sales || {}} />;
  }

  showExpandedRepairs() {
    return (
      this.props.company.get(REPAIR_STATION_STATUS) !== APPROVED &&
      _.some(this.state.stats.repairs, value => Math.abs(value) !== 0)
    );
  }

  showExpandedPurchases() {
    return (
      (this.props.company.get(REPAIR_STATION_STATUS) === APPROVED ||
        this.props.company.get(VENDOR_STATUS) !== APPROVED) &&
      _.some(this.state.stats.purchases, value => Math.abs(value) !== 0)
    );
  }

  showExpandedSales() {
    return (
      (this.props.company.get(REPAIR_STATION_STATUS) === APPROVED ||
        this.props.company.get(VENDOR_STATUS) === APPROVED) &&
      _.some(this.state.stats.sales, value => Math.abs(value) !== 0)
    );
  }

  expandedStats() {
    const { company } = this.props;
    const { stats } = this.state;

    const showRepairs = this.showExpandedRepairs();
    const showPurchases = this.showExpandedPurchases();
    const showSales = this.showExpandedSales();

    if (company.get(REPAIR_STATION_STATUS) === APPROVED) {
      return (
        <React.Fragment>
          {showPurchases && (
            <React.Fragment>
              <StatSeparator />
              <CompanyPurchaseStatsDetail stats={stats.purchases} />
            </React.Fragment>
          )}
          {showSales && (
            <React.Fragment>
              <StatSeparator />
              <CompanySaleStatsDetail stats={stats.sales} />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else if (company.get(VENDOR_STATUS) === APPROVED) {
      return (
        <React.Fragment>
          {showSales && (
            <React.Fragment>
              <StatSeparator />
              <CompanySaleStatsDetail stats={stats.sales} />
            </React.Fragment>
          )}
          {showRepairs && (
            <React.Fragment>
              <StatSeparator />
              <CompanyRepairStatsDetail stats={stats.repairs} />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        {showPurchases && (
          <React.Fragment>
            <StatSeparator />
            <CompanyPurchaseStatsDetail stats={stats.purchases} />
          </React.Fragment>
        )}
        {showRepairs && (
          <React.Fragment>
            <StatSeparator />
            <CompanyRepairStatsDetail stats={stats.repairs} />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { company, currentUser } = this.props;
    const requestApprovalStatuses = [NOT_APPROVED, DENIED];

    const canRequestRepairApproval = requestApprovalStatuses.includes(
      company.get(REPAIR_STATION_STATUS)
    );
    const canRequestVendorApproval = requestApprovalStatuses.includes(
      company.get(VENDOR_STATUS)
    );

    const canRequestUltimateConsigneeForm = get(
      currentUser,
      [TENANT, ULTIMATE_CONSIGNEE_FORM_URL].join(".")
    );

    const actionsAvailable =
      canRequestRepairApproval ||
      canRequestVendorApproval ||
      canRequestUltimateConsigneeForm;
    const {
      editCompanyModalOpen,
      editBillingModalOpen,
      stationConfirmModalOpen,
      ultimateConsigneeOpen,
      vendorConfirmModalOpen,
      viewAllStats
    } = this.state;

    const defaultStats = this.defaultStats();
    const expandedStats = this.expandedStats();
    const showExpandCollapse =
      this.showExpandedRepairs() ||
      this.showExpandedPurchases() ||
      this.showExpandedSales();

    const experts = [
      company.getIn(["resident_expert", "full_name"]),
      company.getIn(["second_resident_expert", "full_name"])
    ]
      .filter(n => n)
      .map(n => getFirstNameLastInitial(n));

    return (
      <Col>
        <div className="page-header page-header-bar">
          <h1>
            {actionsAvailable && (
              <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
                <ActionDropDown
                  menuClass="dropdown-menu-right"
                  style={{ cursor: "pointer" }}
                >
                  {canRequestRepairApproval && (
                    <DropDownItem
                      onClick={() =>
                        this.toggleModalState("stationConfirmModalOpen")}
                    >
                      <span>
                        <i className="fa fa-fw fa-check" />{" "}
                        <span>Request Rep Station Approval</span>
                      </span>
                    </DropDownItem>
                  )}
                  {canRequestVendorApproval && (
                    <DropDownItem
                      onClick={() =>
                        this.toggleModalState("vendorConfirmModalOpen")}
                    >
                      <span>
                        <i className="fa fa-fw fa-check" />{" "}
                        <span>Request Vendor Approval</span>
                      </span>
                    </DropDownItem>
                  )}
                  <RequestUltimateConsignee
                    toggle={() =>
                      this.toggleModalState("ultimateConsigneeOpen")}
                  />
                </ActionDropDown>
              </div>
            )}
            <div className="with-padding">
              <RecordPager baseUrl="/companies" record={company} />
              <span className="header-content">{company.get(NAME)}</span>
              <ClipboardCopy name={company.get(NAME)} type="Company" />
              <span className="small text-muted">{company.get(CODE)}</span>
              <StatusBadges company={company} />
            </div>
          </h1>
        </div>
        <Col md={3}>
          <div className="panel panel-default">
            <div className="panel-body">
              <h2 style={{ marginTop: 10 }}>
                Details
                <Authorized
                  permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
                  roles={without(ROLES, WAREHOUSE)}
                >
                  <EditButton
                    handleClick={() =>
                      this.toggleModalState("editCompanyModalOpen")}
                  />
                  <EditCompany
                    company={company.toJS()}
                    open={editCompanyModalOpen}
                    close={() => this.toggleModalState("editCompanyModalOpen")}
                  />
                </Authorized>
              </h2>
              <DetailsTable company={company} />
              <Fleets />
              <hr />
              <h2 style={{ marginTop: 10 }}>
                Billing
                <Authorized
                  permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
                  roles={without(ROLES, WAREHOUSE)}
                >
                  <EditButton
                    handleClick={() =>
                      this.toggleModalState("editBillingModalOpen")}
                  />
                  <EditBilling
                    company={company.toJS()}
                    open={editBillingModalOpen}
                    close={() => this.toggleModalState("editBillingModalOpen")}
                  />
                </Authorized>
              </h2>
              <BillingTable company={company} />
              <Receivables company={company} />
              <hr />
              <ApprovalsTable company={company} />
              <hr />
              <CustomerRestrictionsTable company={company} />
              <hr />
              <AuditFields record={company} multiLine />
            </div>
          </div>
        </Col>
        <Col md={9}>
          <ExpertHeader experts={experts} />
          <div>
            <h2>
              Stats&nbsp;&nbsp;
              {showExpandCollapse && (
                <span
                  style={{
                    fontSize: 10,
                    textTransform: "none",
                    fontWeight: "normal",
                    color: "#FF9800",
                    cursor: "pointer"
                  }}
                  onClick={this.toggleStats}
                >
                  {viewAllStats ? "Collapse" : "Expand"}
                </span>
              )}
            </h2>
            <div>
              {defaultStats}
              {viewAllStats && expandedStats}
            </div>
          </div>
          <Contacts />
          <PhysicalAddresses region={company.region} />
          <AuditTrail company={company} />
          <ShippingMethods />
          <RelatedCompanies />
          <Row>
            <Col md={6}>
              <Notes
                headerLabel="Company Notes"
                additionalActions={[
                  {
                    key: NOTE_TYPE,
                    onConfirm: postConfirm => note =>
                      api.notes
                        .update(company.get(ID), resourceTypes.company, {
                          ...note.toJS(),
                          [NOTE_TYPE]: ACCOUNTING
                        })
                        .then(({ data }) => postConfirm(data)),
                    label: "Move to Accounting"
                  }
                ]}
                filter={note =>
                  !note.get(NOTE_TYPE) || note.get(NOTE_TYPE) === COMPANY}
                resource={company}
                resourceType={resourceTypes.company}
                resourceKey={COMPANY}
              />
            </Col>
            <Col md={6}>
              <Notes
                headerLabel="Accounting Notes"
                resource={company}
                resourceType={resourceTypes.company}
                notesType="accounting"
              />
            </Col>
          </Row>

          <Attachments
            attachmentTypes={ATTACHMENT_TYPES}
            multiple
            resource={company}
            resourceType={resourceTypes.company}
            resourceKey={COMPANY}
          />
        </Col>
        <ConfirmAction
          onConfirm={this.props.requestVendorApproval}
          close={() => this.toggleModalState("vendorConfirmModalOpen")}
          open={vendorConfirmModalOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to request&nbsp;
          <strong>vendor approval</strong>?
        </ConfirmAction>
        <ConfirmAction
          onConfirm={this.props.requestStationApproval}
          close={() => this.toggleModalState("stationConfirmModalOpen")}
          open={stationConfirmModalOpen}
        >
          <strong>Heads up!</strong> Are you sure you want to request&nbsp;
          <strong>repair station approval</strong>?
        </ConfirmAction>
        <RequestUltimateConsigneeModal
          company={company}
          close={() => this.toggleModalState("ultimateConsigneeOpen")}
          open={ultimateConsigneeOpen}
        />
      </Col>
    );
  }
}

export default connect(
  state => ({
    company: state.companyDetail.get(COMPANY)
  }),
  dispatch => ({
    requestVendorApproval: () =>
      dispatch(actions.update({ request_vendor_approval: true })),
    requestStationApproval: () =>
      dispatch(actions.update({ request_shop_approval: true }))
  })
)(
  loadRecord({
    reducer: "companyDetail",
    name: COMPANY,
    action: getCompany
  })(withCurrentUser(Details))
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Detail.jsx